import { render } from "./Livescoring.vue?vue&type=template&id=817d3fd4&scoped=true"
import script from "./Livescoring.vue?vue&type=script&lang=js"
export * from "./Livescoring.vue?vue&type=script&lang=js"

import "./Livescoring.vue?vue&type=style&index=0&id=817d3fd4&scoped=true&lang=css"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-817d3fd4"]])

export default __exports__